export const addressConstants = {
  googlePlacesConfig: {
    componentRestrictions: { country: ['us'] },
    language: 'en'
  }
};
